import { useEffect, useState } from "react";
import { GameListResponse } from "../../games/models/responses/gameListResponse";
import { fetchTrendingGames, updateFavouriteGame } from "../../games/services/casino.service";
import { GameItem } from "./games/GameItem";
import { localStorageService } from "../../../services/localStorageService";
import localization from "../../../config/localization";

export function TrendingGames() {

    const [trendingGames, setTrendingGames] = useState<GameListResponse>();

    const getTrendingGames = async () => {
        const result = await fetchTrendingGames({
            pageSize: 10,
            fromDate: new Date(new Date().setMonth(new Date().getMonth() - 1)).toISOString(),
            toDate: new Date().toISOString(),
            userId: localStorageService.getItem<string>("userId"),
        });

        if (result.isSuccess) {
            setTrendingGames(result.data ?? undefined);
        }
    };

    useEffect(() => {
        getTrendingGames();
    }, []);


    const handleFavouriteToggle = async (gameId: string, isFavourite: boolean) => {
        await updateFavouriteGame(gameId, isFavourite);
        await getTrendingGames();
    }

    if (trendingGames?.gameList?.length === 0) {
        return null;
    }

    return (
        <div className="text-white bg-dark-gradient rounded-2xl mt-6 p-4 mb-6">
            <div>
                <div className="flex justify-between items-center mb-3">
                    <div className="flex items-center gap-1">
                        <img
                            src={"/icons/ic-trending-games.svg"}
                            alt={'recent played icon'}
                            className="h-6 w-6 object-contain"
                        />
                        <span className="text-lg md:text-xl font-semibold" >
                            {localization.trending_games}
                        </span>
                    </div>
                </div>
                <GameItem games={trendingGames?.gameList} handleFavouriteToggle={(gameId: string, isFavourite: boolean) => handleFavouriteToggle(gameId, isFavourite)} />
            </div>
        </div>
    );
}
